import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { toast } from 'material-react-toastify';
import CustomToast from '../../Components/Toast';
import { destroyUser } from '../../redux/features/User';
const useAuth = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  React.useEffect(() => {
    if (!localStorage.getItem('authToken')) {
      toast(
        <CustomToast
          severity="warning"
          message="Your session has been expired"
        />,
        { closeButton: false }
      );
      dispatch(destroyUser());
      navigate('/login');
    }
  }, []);

  return;
};

export default useAuth;
